import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Tailles de rôle typographique (`tokens.css`, SAAS-1182). `tailwind-merge` ne
 * les connaît pas : sans cette déclaration il les prend pour des couleurs, et
 * `cn('text-fg', 'text-page-title')` supprimait `text-fg`.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['page-title', 'section-title', 'card-title', 'eyebrow'] }],
    },
  },
});

/**
 * `cn` — merge de classes Tailwind avec deduplication intelligente.
 *
 * @remarks
 * Combine `clsx` (gestion des conditionnels et arrays) et `tailwind-merge`
 * (résolution des conflits Tailwind, ex: `'px-4 px-6'` → `'px-6'`).
 *
 * À utiliser **partout** dans le projet pour composer des classes Tailwind.
 *
 * @example
 * ```ts
 * cn('text-sm', isActive && 'font-bold', className)
 * cn('px-4', condition ? 'bg-red-500' : 'bg-blue-500')
 * ```
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
